import { findIndex } from 'lodash';

import { Asset, BrokerInterviews, Company, Liability, RelatedParty, StoreApplicant } from '@funnels/types';

type ArrayData = StoreApplicant | Asset | Liability | RelatedParty | BrokerInterviews | Company;

export default function getIndexFromId(data: ArrayData[], id?: string) {
  return findIndex(data, (obj: ArrayData) => obj.id === id);
}
